<template lang="pug">
v-app#insight.secondary
  template(v-if="getLogin && getProfile")
    SnackBar

  //- 側邊選單 (800px 以下由左向右滑入)
  v-navigation-drawer(
    v-model="drawer"
    fixed temporary left
    width="100%"
    color="secondary")
    v-btn.v-navigation-drawer-close.pa-3(@click="drawer = false" icon ripple)
      v-icon mdi-close
    v-list.pa-4(nav dense)
      v-list-item.mb-6
        v-img(max-width="140" :src="`${STATIC_URL}images/logo.png`")

      template(v-if="getLogin")
        v-list-item.pa-1(to="/" active-class="transparent-nav")
          v-list-item-title.px-4.text-14 關於
        v-list-item.pa-1(to="/models" active-class="transparent-nav")
          v-list-item-title.px-4.text-14 我的模型
        v-list-item.pa-1(to="/history" active-class="transparent-nav")
          v-list-item-title.px-4.text-14 使用紀錄
        v-divider.my-4
        v-list-item(@click="accountVisible = true").px-4.py-2
          v-list-item-avatar(size="30")
            v-img(:src="getProfile?.thumbSrc")
          v-list-item-title 帳戶 ({{ getProfile?.name }})
      
      template(v-else)
        v-list-item.pa-1(to="/" active-class="")
          v-list-item-title.px-4.text-14 關於
        v-list-item.pa-1(to="/store" active-class="")
          v-list-item-title.px-4.text-14 模型園地
        v-btn.d-flex.line-theme.mx-1.mt-2.w-100(
          height="48"
          @click="lineLogin()")
          IconLine(:size="16")
          span.text-14 登入 / 註冊會員

  v-app-bar(
    color='secondary'
    app dense dark
    height="66"
    elevation="0")
    .d-flex.align-center.justify-space-between.fill-height.px-sm-2.w-100
      v-toolbar-title
        v-img(
          :max-width="logoMaxWidth"
          :src="`${STATIC_URL}images/logo.png`")

      v-spacer

      //- 桌面選單 (800px 以上)
      .d-menu-desktop(v-if="getLogin")
        v-btn.rounded-lg(text large elevation="0" to="/") 關於
        v-btn.rounded-lg.mx-2(text large elevation="0" to="/models") 我的模型
        v-btn.rounded-lg(text large elevation="0" to="/history") 使用紀錄
        v-btn.rounded-lg.mt-0.mx-1(
          color="transparent"
          elevation="0"
          large
          :ripple="false"
          @click="accountVisible = true")
          v-img.mx-auto.border-circle(
            lazy-src=""
            max-width="30"
            max-height="30"
            :src="getProfile?.thumbSrc")
          span.text-14.pl-2 帳戶

      .d-menu-desktop(v-else)
        v-btn.rounded-lg(text large elevation="0" to="/") 關於
        v-btn.rounded-lg.mx-2(text large elevation="0" to="/store") 模型園地
        v-btn.rounded-lg(text large elevation="0" @click="lineLogin()") 立即登入
        //- v-btn.line-theme.rounded-lg.ml-2(
        //-   elevation="0"
        //-   @click="lineLogin()")
        //-   IconLine(:size="20" class="mr-2")
        //-   span 立即登入

      //- 漢堡圖標 (800px 以下)
      v-app-bar-nav-icon.d-menu-mobile(@click="drawer = !drawer")

  v-main
    v-container.pa-0(fluid)
      transition(:name="transitionName")
        router-view

  v-footer.secondary.pa-8.align-center.justify-center
    //- .d-block.text-12.dark1--text.pt-1.text-center Cancell 健細胞科技 @ 2026
    .d-block.text-12.dark1--text.pt-1.text-center Copyright © 2026 Cancell Tech. All rights reserved.

  CommonDialog(v-model="accountVisible" max-width="400" hide-close)
    v-card-title.font-bold.justify-center.text-center.font-weight-bold
      v-avatar(width="120px" height="120px").mb-2
        v-img.mx-auto.rounded-lg( :src="getProfile?.thumbSrc")
      v-card-text.font-weight-bold.text-24.pa-0.mb-1 {{ getProfile?.name }}
      v-card-text.font-weight-bold.text-16.pa-0.mb-4 {{ getProfile?.email }}
      v-card-text.pa-0.mb-4
        span.text-14.grey--text(v-if="getProfile?.team_id") {{ getProfile?.team_name }}
        span.text-14(v-else)
          span.grey--text 您尚未加入團隊，
          a.white--text(href="https://docs.google.com/forms/d/e/1FAIpQLSdNwMzSPS80bsJ0XbvH4neVHaVGqZFMwuAvwxRSnbDy35-lSw/viewform?usp=dialog" target="_blank") 請聯繫客服尋求協助
    v-card-actions.pt-0.px-4
      v-spacer
      v-btn.rounded-lg(large color="error" text @click="handelLogout()")
        v-icon(left size="14") mdi-logout
        | 登出
      v-btn.mt-10(fab absolute top right elevation="0" @click="accountVisible = false")
        v-icon mdi-close

  MessageBox(
    :active='msgBox.active'
    :showType='msgBox.type'
    :showContent='msgBox.content')

</template>
<script>
import CommonDialog from '@/components/dialog/CommonDialog.vue'
import MessageBox from '@/components/messageBox/MessageBox.vue';
export default {
  components: {
    MessageBox,
    CommonDialog,
    IconLine: () => import('@/components/icons/Line.vue'),
    SnackBar: () => import('@/components/SnackBar.vue'),
  },

  data: () => ({
    drawer: false,
    value: "",
    transitionName: '',
    accountVisible: false,
  }),

  computed: {
    logoMaxWidth() {
      if (this.rwdType === 'small') return 140;
      if (this.rwdType === 'medium') return 160;
      return 160;
    }
  },

  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },

  watch: {
    $route(to, from) {
      if (to.name === 'chat-room' && from.name === 'chat') {
        this.transitionName = 'slide-left';
      } else if (to.name === 'chat' && from.name === 'chat-room') {
        this.transitionName = 'slide-right';
      } else {
        this.transitionName = '';
      }
    }
  },
  methods: {
    handleResize() {
      const width = window.innerWidth;
      let type = 'desktop';
      if (width < 736) {
        type = 'small';
      } else if (width < 1280) {
        type = 'medium';
      }
      this.$store.commit('global/SET_RWD_TYPE', type);
    },
    handelLogout() {
      this.mutateLogout()
      this.accountVisible = false
      if (this.$route.name !== 'main')
        this.$router.push({ name: 'main' })
    },
    lineLogin() {
      window.location.href = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${this.LINE_LOGIN_ID}&state=login&redirect_uri=${this.LINE_LOGIN_DOMAIN}/line/authorize&scope=profile%20openid%20email&nonce=basic&ui_locales=zh-TW`
    }
  }
}

</script>
<style lang="scss">
.v-navigation-drawer-close {
  position: absolute;
  top: 18px;
  right: 18px;
  z-index: 2;
}

@import 'scss/default';

body,
html {
  background: #121212;
  scrollbar-gutter: stable;
}

.theme--dark.v-application {
  background: #121212 !important;
  // 已修正：恢復佈局以確保導航功能正常
  // display: block; 

  .v-application--wrap {
    background: #121212 !important;
    min-height: 100dvh;
    // flex: unset; 
  }

  .v-main {

    .v-main__wrap,
    .v-navigation-drawer {
      background: #121212 !important;
    }

    .v-main__wrap {
      position: relative;
      width: 100%;
    }
  }
}

// 800px 響應式切換
@media screen and (min-width: 801px) {
  .d-menu-desktop {
    display: flex !important;
    align-items: center;
  }

  .d-menu-mobile {
    display: none !important;
  }
}

@media screen and (max-width: 800px) {
  .d-menu-desktop {
    display: none !important;
  }

  .d-menu-mobile {
    display: flex !important;
  }
}

.transparent-nav {
  background-color: transparent !important;

  &:before {
    background-color: transparent !important;
  }
}

/* Slide Transitions */
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform 0.3s ease;
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  padding-left: 12px;
  padding-right: 12px;
}

.slide-left-enter {
  transform: translateX(100%);
}

.slide-left-leave-to {
  transform: translateX(-100%);
}

.slide-right-enter {
  transform: translateX(-100%);
}

.slide-right-leave-to {
  transform: translateX(100%);
}
</style>
